
























import Sidebar from './Sidebar.vue'
import Breadcrumb from './Breadcrumb.vue'
import PureRouterView from './PureRouterView.vue'
import Watermark from './Watermark.vue'
import Status from './Status.vue'
import TenantNavigationShell from '@/components/TenantNavigationShell/index.vue'
import TenantMainShell from '@/components/TenantMainShell/index.vue'
import { appCode } from '@/config'

import { Component, Prop, Vue } from 'vue-property-decorator'
@Component({
    components: {
        Breadcrumb,
        Sidebar,
        PureRouterView,
        Watermark,
        Status,
        TenantNavigationShell,
        TenantMainShell
    }
})
export default class LayoutComponent extends Vue {
    @Prop() private msg!: string

    isCollapse = false
    activeIndex = appCode

    get authInfo() {
        return this.$store.state.auth.authInfo
    }

    get apps() {
        return this.authInfo && this.authInfo.apps || []
    }

    get logoUrl() {
        return this.$store.getters.tenantLogoUrl
    }

    get tenantName() {
        return this.$store.getters.tenantName
    }

    collapsed(collapse: boolean): void {
        this.isCollapse = collapse
    }

    go(item: any) {
        location.href = item.path || item.url || `/${item.code}`
    }
}
